import { Link } from "react-router-dom";
import { periodLabel } from "@/hooks/useEuroLive";

const when = (iso) => iso && new Date(iso).toLocaleString("en-GB", { timeZone: "Europe/Athens", day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });

function Status({ g, lv }) {
  if (lv?.live) return <small className="eu-live" data-testid={`europe-live-${g.id}`}><em><i />LIVE</em>{[periodLabel(lv.quarter), lv.clock].filter(Boolean).join(" · ")}</small>;
  if (lv?.final) return <small className="eu-live eu-final" data-testid={`europe-final-${g.id}`}><em>FINAL</em>{g.round_name}</small>;
  return <small>{when(g.date_utc)}<em>{g.round_name}</em></small>;
}

export function EuroGameRow({ comp, g, focus, live }) {
  const lv = live?.[g.id];
  const hp = lv ? lv.home_pts : g.home_pts;
  const ap = lv ? lv.away_pts : g.away_pts;
  const scored = g.played || lv;
  const homeWin = scored && hp > ap;
  const awayWin = scored && ap > hp;
  const res = focus && g.played ? ((g.home.code === focus) === homeWin ? "W" : "L") : null;
  return (
    <div className={`eu-game ${lv?.live ? "is-live" : ""}`} data-testid={`europe-game-${g.id}`}>
      <Status g={g} lv={lv} />
      <Link to={`/europe/${comp}/teams/${g.home.code}`} className={homeWin ? "w" : ""}><img src={g.home.crest} alt="" loading="lazy" /><span className="eu-long">{g.home.short}</span><span className="eu-code">{g.home.tv}</span></Link>
      <Link to={`/europe/${comp}/games/${g.id}`} className="eu-game-link" title="Box score" data-testid={`europe-game-link-${g.id}`}>
        <b data-testid={`europe-score-${g.id}`}>{scored ? <><i className={homeWin ? "w" : ""}>{hp}</i> - <i className={awayWin ? "w" : ""}>{ap}</i></> : "vs"}</b>
      </Link>
      <Link to={`/europe/${comp}/teams/${g.away.code}`} className={awayWin ? "w" : ""}><span className="eu-long">{g.away.short}</span><span className="eu-code">{g.away.tv}</span><img src={g.away.crest} alt="" loading="lazy" /></Link>
      {res && <span className={`eu-res ${res === "W" ? "win" : "loss"}`}>{res}</span>}
    </div>
  );
}

export function EuroGames({ title, id, comp, games, live }) {
  return (
    <section className={`ncs-card ${id === "live" ? "eu-live-card" : ""}`} data-testid={`europe-${id}`}>
      <h3>{id === "live" && <i className="eu-dot" />}{title}</h3>
      {games.map((g) => <EuroGameRow key={g.id} comp={comp} g={g} live={live} />)}
      {!games.length && <p className="ncs-muted">No games.</p>}
    </section>
  );
}
